"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoComplete = void 0;
var withMName_1 = require("../../utils/withMName");
var Backbone = __importStar(require("backbone"));
var underscore_1 = __importDefault(require("underscore"));
var AutoComplete = /** @class */ (function (_super) {
    __extends(AutoComplete, _super);
    function AutoComplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selected = -1;
        _this.suggestions = [];
        _this.shownSuggestions = 0;
        _this.match = false;
        return _this;
    }
    AutoComplete.prototype.events = function () {
        return {
            'keyup :text': this.onKeyField.mname,
            'focus :text': this.onFieldFocus.mname,
            'blur :text': this.onFieldBlur.mname,
            'click .js-suggestion': this.onClickSuggestion.mname,
            'submit': this.onFormSubmit.mname
        };
    };
    AutoComplete.prototype.initialize = function () {
        underscore_1.default.bindAll(this, this.onClickSuggestion.mname, this.onKeyField.mname, this.onFormSubmit.mname, this.onFieldFocus.mname, this.onFieldBlur.mname);
        this.$el.data('view', this);
        this.names = Muni.data.autocompleteNames;
        if (this.$el.data('includeSweden')) {
            this.names.push('Sverige');
        }
        this.selected = -1;
        this.suggestions = [];
        this.shownSuggestions = 0;
        this.field = this.$el.find(':text');
        this.button = this.$el.find(':submit');
        this.numberOfSuggestions = this.$el.data('number-of-suggestions') || AutoComplete.NUMBER_OF_SUGGESTIONS;
        return this.updateFormStatus();
    };
    AutoComplete.prototype.render = function () {
        this.$el.find('.js-suggestions').hide();
        this.displaySuggestions();
        return this;
    };
    AutoComplete.prototype.onFormSubmit = function (e) {
        if (!this.match) {
            return e.preventDefault();
        }
    };
    AutoComplete.prototype.onClickSuggestion = function (e) {
        var _a;
        e.preventDefault();
        (_a = this.field) === null || _a === void 0 ? void 0 : _a.val($(e.target).data('suggestion'));
        this.hideSuggestions();
        this.updateFormStatus();
        this.$el.trigger('suggestion:clicked');
        return this.$el.submit();
    };
    AutoComplete.prototype.onKeyField = function (e) {
        var _a, _b, _c;
        switch (e.keyCode) {
            case 38:
                this.selected = ((this.selected - 1) + this.shownSuggestions) % this.shownSuggestions;
                this.displaySuggestions();
                this.updateFormStatus();
                break;
            case 40:
                this.selected = (this.selected + 1 + this.shownSuggestions) % this.shownSuggestions;
                this.displaySuggestions();
                this.updateFormStatus();
                break;
            case 13:
                if (this.$el.data('allowEmpty') && (((_a = this.field) === null || _a === void 0 ? void 0 : _a.val()) === '')) {
                    this.hideSuggestions();
                    this.updateFormStatus();
                    this.$el.trigger('suggestion:clicked');
                    this.field.blur();
                }
                else if (this.selected !== -1) {
                    (_b = this.field) === null || _b === void 0 ? void 0 : _b.val(this.suggestions[this.selected]);
                    this.hideSuggestions();
                    this.updateFormStatus();
                    (_c = this.field) === null || _c === void 0 ? void 0 : _c.blur();
                    this.$el.trigger('suggestion:clicked');
                    this.$el.submit();
                }
                break;
            default:
                this.displaySuggestions();
                this.updateFormStatus();
        }
    };
    AutoComplete.prototype.onFieldFocus = function () {
        return this.displaySuggestions();
    };
    AutoComplete.prototype.onFieldBlur = function () {
        return setTimeout(underscore_1.default.bind(this.hideSuggestions, this), 200);
    };
    AutoComplete.prototype.hideSuggestions = function () {
        return this.$el.find('.js-suggestions').hide();
    };
    AutoComplete.prototype.displaySuggestions = function () {
        var _a, _b, _c, _d;
        this.hideSuggestions();
        var search = (_b = (_a = this.field) === null || _a === void 0 ? void 0 : _a.val()) === null || _b === void 0 ? void 0 : _b.toString().toLowerCase();
        if (!search) {
            return;
        }
        var matches = underscore_1.default.filter((_c = this.names) !== null && _c !== void 0 ? _c : [], function (name) { return name.toLowerCase().indexOf(search) !== -1; });
        matches.sort();
        matches = underscore_1.default.sortBy(matches, function (match) { return match.toLowerCase().indexOf(search); });
        if (matches.length) {
            this.suggestions = underscore_1.default.take(matches, (_d = this.numberOfSuggestions) !== null && _d !== void 0 ? _d : 0);
            this.shownSuggestions = this.suggestions.length;
            this.$el.find('.js-suggestions')
                .html(AutoComplete.template({ suggestions: this.suggestions, selected: this.selected }))
                .show();
        }
    };
    AutoComplete.prototype.updateFormStatus = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var value = (_b = (_a = this.field) === null || _a === void 0 ? void 0 : _a.val()) === null || _b === void 0 ? void 0 : _b.toString().toLowerCase();
        var foundMatch = underscore_1.default.find((_c = this.names) !== null && _c !== void 0 ? _c : [], function (name) { return name.toLowerCase() === value; });
        if (foundMatch) {
            (_d = this.field) === null || _d === void 0 ? void 0 : _d.trigger('suggestion:match');
            (_e = this.field) === null || _e === void 0 ? void 0 : _e.val(foundMatch);
            this.match = true;
            return (_f = this.button) === null || _f === void 0 ? void 0 : _f.attr('disabled', false.toString());
        }
        else {
            (_g = this.field) === null || _g === void 0 ? void 0 : _g.trigger('suggestion:miss');
            this.match = false;
            return (_h = this.button) === null || _h === void 0 ? void 0 : _h.attr('disabled', true.toString());
        }
    };
    AutoComplete.NUMBER_OF_SUGGESTIONS = 14;
    AutoComplete.template = underscore_1.default.template("\n        <% for (var i = 0; i < suggestions.length; i++) { %>\n          <li><a href=\"#\" data-suggestion=\"<%= suggestions[i] %>\" class=\"js-suggestion<%= i == selected ? ' selected' : '' %>\"><%= suggestions[i] %></a></li>\n        <% } %>\n    ");
    __decorate([
        withMName_1.withMName
    ], AutoComplete.prototype, "onFormSubmit", null);
    __decorate([
        withMName_1.withMName
    ], AutoComplete.prototype, "onClickSuggestion", null);
    __decorate([
        withMName_1.withMName
    ], AutoComplete.prototype, "onKeyField", null);
    __decorate([
        withMName_1.withMName
    ], AutoComplete.prototype, "onFieldFocus", null);
    __decorate([
        withMName_1.withMName
    ], AutoComplete.prototype, "onFieldBlur", null);
    return AutoComplete;
}(Backbone.View));
exports.AutoComplete = AutoComplete;
